<template>
  <div class="detaicont">
    <div class="header">
      <span class="h_back" @click="back"></span>
      <span class="h_title">{{tMusic.museumName}}</span>
    </div>
    <div class="progress">
      <img :src="tMusic.pictureUrl" alt="" :onerror="defaultImg">
      <div class="gressbar" v-show="tMusic.audioUrl">
        <span class="curr">{{time}}</span>
        <span class="total">/{{totle}}</span>
      </div>
    </div>
    <p class="name">{{tMusic.collectionName}}</p>
    <p class="mumu">{{tMusic.museumName}}</p>
    <p class="introduce">
     {{tMusic.description}}
    </p>
    <div class="player" v-show="tMusic.audioUrl">
      <div class="playcont">
        <img class="ico" src="../assets/images/guide/playpre.png" alt="" @click.stop="isPre">
        <img class="icos" src="../assets/images/guide/playstop.png" alt="" v-show="!playorpause" @click="isPlay">
        <img class="icos" src="../assets/images/guide/playplay.png" alt="" v-show="playorpause" @click="isStops">
        <img class="ico" src="../assets/images/guide/playnext.png" alt="" @click.stop="isNext">
      </div>
      <audio ref="audio" style="display: none" id="player" preload  @ended="isNext"></audio>
    </div>
  </div>
</template>

<script>
  import {api} from '../global/api';
  import { mapState, mapMutations, mapGetters } from "vuex";
    export default {
        name: "themeDetail",
      data(){
          return{
            time:0,
            totle:0,
            index:0,
            tList:[],
            tMusic:[],
            tPlaying:"",
            tIndex:0,
            playorpause:true,
            defaultImg: this.$store.getters.defaultImg,
            bar:0,
            timer:null,
            currentId:"",
            collectionId:"",
            tourId:"",
            currentData:{},
          }
      },
      computed: mapState({
        count:state=>state.audio
      }),
      watch:{
        'index':'getMusic',
        count:function (newval,oldval) {

        }
      },
      mounted(){
        let _this = this;
        _this.collectionId=_this.$route.query.collectionId;
        _this.tourId=_this.$route.query.tourId;
        var audio = document.getElementById("player");
        var gressbar = document.getElementsByClassName("gressbar");
        var w = gressbar[0].style.width;
        var W=document.body.clientWidth-w;
        this.timer=setInterval(function (){
          _this.time = audio && audio.currentTime && _this.formatSeconds(audio.currentTime);
          _this.totle = audio && audio.duration && _this.formatSeconds(audio.duration);

          if(audio && audio.currentTime && audio.duration&&!audio.paused){
            gressbar[0].style.left=audio.currentTime/audio.duration*W+"px"
          }

        },1000);
       /* this.$once('hook:beforeDestroy', () => {
          clearInterval(timer);
          timer.destroy()
        })*/
        this.init();
        document.getElementById("player").pause();
      },
      beforeRouteLeave(to,from,next){
        document.getElementById("player").pause();
        next()
      },
      beforeDestroy(){

          if(this.timer){
            clearInterval(this.timer);
            this.timer=null;
          }
      },
      methods:{
        init(){
          var _this=this;
          document.getElementById("player").pause();
          document.getElementById("player").currentTime="0";
          this.tMusic="";
          this.$http.get(api.themedetail+"?collectionId="+_this.collectionId+"&tourId="+this.tourId).then(response => {
            _this.tList=response.data.data.collectionList;
            _this.index=response.data.data.showNum-1;
            _this.$nextTick(()=> {
                _this.tMusic = response.data.data.collectionList[response.data.data.showNum - 1];
                _this.count.audioshow = false;
                _this.$store.dispatch('isPause');
                //document.getElementById("player").play();
              setTimeout(()=>{
                document.getElementById("player").src = _this.tMusic.audioUrl
                //document.getElementById("player").play()
              }, 0)
                _this.playorpause = false;
              })
          })
        },
        getMusic(p){
          this.tMusic="";
          document.getElementById("player").currentTime="0";
          if(p < this.tList.length) {
            // this.music = response.music[p]
            this.tMusic = this.tList[this.index]
          }
          if(p >= this.tList.length){
            this.index = 0;
            this.tMusic = this.tList[this.index]
          }
          if(p < 0){
            this.index = this.tList.length
            this.tMusic = this.tList[this.index]
          }
          document.getElementById("player").pause();
          this.playorpause=false;
        },
        isPlay(index){
          this.count.audioshow=false;
          this.count.playing=false;
          console.log(this.$store.state.audio.audioshow);
          if(this.$store.state.audio.audioshow){
            this.$store.dispatch('isPause');

          }
          document.getElementById("player").play();
          this.playorpause=true;
          return false
        },
        isStops(){
         /* this.count.audioshow=true;
          this.count.playing=true;*/
          console.log(this.$store.state.audio.audioshow);
          document.getElementById("player").pause();
          if(this.$store.state.audio.audioshow){
            this.$store.dispatch('isPlay');
          }

          this.playorpause=false;

          return false
        },
        isNext(){
          this.index++;
          this.playorpause=true;
        },
        isPre(){
          this.index--;
          this.playorpause=true;
        },
        formatSeconds(value) {
          var hh = parseInt(value/3600);
          if(hh<10) hh = "0" + hh;
          var mm = parseInt((value-hh*3600)/60);
          if(mm<10) mm = "0" + mm;
          var ss = parseInt((value-hh*3600)%60);
          if(ss<10) ss = "0" + ss;
          // var length = hh + ":" + mm + ":" + ss;
          var length =  mm + ":" + ss;
          if(value>0){
            return length;
          }else{
            return "NaN";
          }
        },
        back(){
          this.$router.go(-1);
        }
      }
    }
</script>

<style scoped>
  .header{
    width:100%;
    height: 2.25rem;
    background-color: rgba(196, 77, 65, 1);
    position: fixed;
    top: 0;
    z-index: 100;
  }
  .header span{
    display: block;
  }
  .h_title{
    height:  2.25rem;
    line-height:  2.25rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    width: 9rem;
    margin: 0 auto;
  }
  .h_back{
    background: url("../../static/images/cp_backbtn.svg") center no-repeat;
    background-size: 100% 100%;
    width: .55rem;
    height: 1rem;
    position: absolute;
    left: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .player{
    position: fixed;
    bottom:0rem;
    width: 100%;
    height: 3.6rem;
    background-color: white;
  }
  .playcont{
    display: flex;
    height: 2.1rem;
    justify-content: space-around;
    width: 9.5rem;
    margin: 0 auto;
  }
  .player .ico{
    width: .9rem;
    height: .8rem;
    margin-top: .65rem;
  }
  .player .icos{
    width: 2.1rem;
    height: 2.1rem;
  }
.detaicont{
padding-bottom: 5rem;
  position: relative;
}
.mumu{
  width: 16rem;
  height:0.9rem;
  font-size:0.65rem;
  font-family:PingFang-SC-Regular;
  font-weight:400;
  color:rgba(185,185,185,1);
  margin: 0 auto 1.5rem;
  line-height:0.9rem;
  text-align: center;
}
.introduce{
  width:16.25rem;
  margin: 0 auto;
  font-size:0.7rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:1.5rem;
  text-indent: 1.4rem;
}
.name{
  width: 16rem;
 margin: 1.25rem auto .25rem;
  height:1.05rem;
  font-size:0.75rem;
  text-align: center;
  font-family:PingFang-SC-Bold;
  font-weight:bold;
  color:rgba(102,102,102,1);
  line-height:1.05rem;
}
  .progress{
    position: relative;
    margin-top: 2.25rem;
  }
  .progress img{
    width: 100%;
    height: 14.05rem;
  }
  .gressbar{
    position: absolute;
    bottom: 0;
    left: 0;
    height:0.9rem;
    background:rgba(0,0,0,1);
    box-shadow:0.1rem 0.1rem 0.3rem 0rem rgba(0,0,0,0.5);
    border-radius:0.45rem;
    opacity:0.7;
    padding: .1rem .4rem;
  }
  .curr{
    height:0.7rem;
    font-size:0.5rem;
    font-family:PingFang-SC-Regular;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:0.8rem;
    vertical-align: top;
  }
  .total{
    height:0.7rem;
    font-size:0.5rem;
    font-family:PingFang-SC-Regular;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:0.8rem;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/view/themeDetail.vue